export const projects = [
  {
    projectName: "Spring Boot e-commerce app",
    projectDescription:
      "I tried to build an e-commerce application as close as possible to the real use case. I categorized products and added listing features. I created add to cart and purchase features",
    projectLink:
      "https://github.com/barisseckin/E-Commerce",
    projectImage:
      "https://i.ibb.co/dt0Y5R7/Screenshot-from-2022-10-10-15-01-57.png",
  },

];
